export const DEFAULT_CURRENCY = "AED";

export const CURRENCY_OPTIONS = [
  { value: "AED", label: "AED - UAE Dirham" },
  { value: "USD", label: "USD - US Dollar" },
];

const formatters = {};

function formatterFor(code) {
  if (!formatters[code]) {
    try {
      formatters[code] = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: code,
        maximumFractionDigits: 0,
      });
    } catch {
      formatters[code] = formatterFor(DEFAULT_CURRENCY);
    }
  }
  return formatters[code];
}

export function formatMoney(amount, code = DEFAULT_CURRENCY) {
  return formatterFor(code || DEFAULT_CURRENCY).format(Math.round(Number(amount) || 0));
}
